import React, { ReactNode, forwardRef } from 'react'

import clsx from 'clsx'

interface Props {
  children?: ReactNode
  background?:
    | 'primary'
    | 'caution'
    | 'caution-secondary'
    | 'info'
    | 'info-secondary'
    | 'tertiary'
    | 'transparent'
  multipleItems?: ReactNode[]
  checkbox?: boolean
  sticky?: 0 | 40 | 58
  type?: 'default' | 'low' | 'thin'
  scrollShadow?: boolean
  float?: boolean
  width?: number
  height?: number
  covering?: boolean
  radius?: boolean | 'first' | 'last'
}

const TableHeadItem = forwardRef<HTMLTableCellElement, Props>(
  (
    {
      children,
      background,
      checkbox = false,
      multipleItems,
      sticky,
      type = 'default',
      scrollShadow = false,
      float = false,
      width = undefined,
      height = undefined,
      covering = false,
      radius = false
    },
    ref
  ) => {
    const stickyPosition =
      sticky == 0 ? 'left-0' : sticky == 40 ? 'left-10' : sticky == 58 ? 'left-[58px]' : ''
    const Tag = float ? 'div' : 'th'
    return (
      <Tag
        className={clsx(
          'text-left whitespace-nowrap first:pl-3 last:pr-3',
          checkbox && 'pr-3.5',
          covering
            ? 'z-fixed-bottom absolute ml-10 w-[calc(100%-40px)]'
            : stickyPosition
              ? `sticky ${stickyPosition} z-sticky`
              : 'relative z-0',
          type == 'low' ? 'px-3 py-2.5' : type == 'thin' ? 'px-3 py-1' : 'px-1.5 py-2.5',
          scrollShadow && 'min-h-[40px] drop-shadow-[1px_0_0_rgba(235,235,235,1)]',
          height && 'place-content-center',
          radius === true && 'first:rounded-tl-xl last:rounded-tr-xl',
          radius == 'first' && 'rounded-l-2xl',
          radius == 'last' && 'rounded-r-2xl',
          background == 'caution'
            ? 'bg-surface-caution'
            : background == 'caution-secondary'
              ? 'bg-fill-caution-secondary'
              : background == 'info'
                ? 'bg-surface-info'
                : background == 'info-secondary'
                  ? 'bg-fill-info-secondary'
                  : background == 'transparent'
                    ? 'bg-surface'
                    : background == 'tertiary'
                      ? 'bg-sumi-20'
                      : 'bg-surface-secondary'
        )}
        ref={ref}
        style={{ minWidth: width, width: width, maxWidth: width, height: height }}
      >
        {multipleItems ? (
          <>
            <div className='flex gap-x-3'>
              {multipleItems.map((multipleItem: ReactNode, index: number) => (
                <div className='w-[88px]' key={index}>
                  {multipleItem}
                </div>
              ))}
            </div>
          </>
        ) : (
          <>{children}</>
        )}
      </Tag>
    )
  }
)

export default TableHeadItem
